import { useAccountUsers } from '@/hooks/query';
import { useAppSelector } from '@/hooks/store';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { selectCurrentAccount } from '@/store/features/account';
import {
  FREE_TRIAL_USER_LIMIT,
  isTrialRestricted,
  PostHogFeatureFlags,
} from '@/utils/posthog';

export const useIsAtTrialUserLimit = (): boolean => {
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { canUseFeature, accountCanUseFeature } = useFeatureFlag();

  const { users: totalUsers } = useAccountUsers({
    accountId: currentAccount?.id,
  });

  return (
    !!currentAccount &&
    isTrialRestricted(currentAccount) &&
    (canUseFeature(PostHogFeatureFlags.FREE_TRIAL_PLATFORM_RESTRICTIONS) ||
      accountCanUseFeature(
        PostHogFeatureFlags.FREE_TRIAL_PLATFORM_RESTRICTIONS,
        currentAccount?.featureFlagAbility,
      )) &&
    (totalUsers?.count ?? 0) >= FREE_TRIAL_USER_LIMIT
  );
};
